import React from 'react';
import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import * as SearchFilters from 'ha/types/SearchFilters';
import RadioGroup from 'ha/components/next/FormFields/RadioGroup';

interface Props {
  bills: SearchFilters.BillsFilterValue;
  onChange: (value: SearchFilters.BillsFilterValue) => void;
}

interface BillOption {
  value: SearchFilters.BillsValue;
  title: string;
  dataTestLocator?: string;
}

export const BillsFilter: React.FC<Props & IntlProps> = ({
  bills,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="BillsFilter Title">
      {T('Bills')}
    </Typography.ParagraphTitle>

    <RadioGroup
      input={{
        value: bills as string,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value as SearchFilters.BillsFilterValue),
      }}
      options={
        [
          {
            value: SearchFilters.BillsValue.INCLUDED,
            title: T('Bills Included'),
            dataTestLocator: 'Filter Bills Included',
          },
          {
            value: SearchFilters.BillsValue.EXCLUDED,
            title: T('Bills Excluded'),
            dataTestLocator: 'Filter Bills Excluded',
          },
        ] as BillOption[]
      }
    />
  </React.Fragment>
);

export default withIntl(BillsFilter);
